import React from "react";
import { useTranslation } from "react-i18next";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";

const VK = "TechnicalDetails"; // VariablesKey
export default function TechnicalDetails(props) {
    const { t } = useTranslation();

    const { set, variables } = props;

    function onChange(event) {
        set({ ...variables, [VK]: event.target.value });
    }

    function onBlur(event) {
        set({ ...variables, [VK]: event.target.value.trim() });
    }

    return (
        <>
            <h3 className="text-left">{t("Technical Details")}:</h3>

            <p className="text-left">
                {t(
                    "If your offering a product or a service with specific parameters like dimensions, packaging, or what comes inside please specify them in the field below."
                )}
            </p>

            <InputAutoresize
                onChange={onChange}
                onBlur={onBlur}
                value={variables[VK]}
                placeholder={t("Start typing")}
                fullWidth
                multirow
                rows={6}
            />
        </>
    );
}
